// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table td.paid-passengers,\n.el-table th.paid-passengers {\n  width: 10em;\n}\n.el-table td.paid-passengers {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
